import { MainItem } from "../MainItem";
import { items } from "./ItemsData";

export const Certificates = () => {
  return <MainItem heading={"Certificates"} subItems={items} />;
};
